import { identifyUserActionType } from '../../actionTypes';
import { identifyUser } from './../../api/controllers/buyWithInstacredController';
import Utils, { setSessionStorage } from '../../utils';
import { clearLoginData } from '../../utils/helper';
import { storeLenderId } from '../../utils/lenderTheme';

export default () => (dispatch) => {
  identifyUser()
    .then(({ data }) => {
      dispatch({
        type: identifyUserActionType.IDENTIFY_USER_SUCCESS,
        payload: {
          data,
        },
      });
      if (
        Object.keys(data.authDetails).length &&
        data.permissions.includes('AUTHENTICATED')
      ) {
        const { m: mobile } = data.authDetails;
        setSessionStorage(
          'authDetails',
          JSON.stringify({
            login: true,
            mobile,
          }),
        );
      } else {
        clearLoginData();
        if (!Utils.isOrganicSite()) {
          storeLenderId(Utils.getLenderIdsFromSubDomain()[0] || '');
        }
      }
    })
    .catch(({ data }) => {
      const { message } = data || {};
      dispatch({
        type: identifyUserActionType.IDENTIFY_USER_FAILURE,
        payload: { errorMessage: message },
      });
    });
};



// WEBPACK FOOTER //
// ./actions/identifyUserAction/index.js